import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-date-picker';
import moment from 'moment';

export default class JournalDatePicker extends Component {
  state = {
    value: moment(new Date()).subtract(122, 'years').toDate(),
  }

  handleChange = (date) => {
    const { onChange } = this.props;
    this.setState({ value: date });
    onChange(date);
  }

  render = () => {
    const { value } = this.state;
    return (
      <DatePicker
        className="journal-date-picker"
        maxDate={new Date()}
        onChange={this.handleChange}
        value={value}
      />
    );
  }
}

JournalDatePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
};